(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    

  const formPopup = document.getElementById('newsletter-sections--20834612674890__newsletter-popup')
  
      /* LOAD */
      _iub.cons_instructions.push(['load', {
        form: {
          selector: formPopup,
          map: {
            subject: {
              email: 'contact[email]'
            },
            preferences: {
                privacy: "privacy",
                newsletter: "newsletter"
            },
          }
        },
          consent: {
              legal_notices: [
                {
                  identifier: "privacy_policy",
                },
                {
                  identifier: "cookie_policy",
                }
            ]
          }
      }]);


  formPopup?.addEventListener('submit', function (e) {
    _iub.cons.sendData();

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !window.DesignMode) return;
  try {
    

  const formNl = document.getElementById('newsletter-form-template--21095808696650__newsletter_pchwwM')
  
      /* LOAD */
      _iub.cons_instructions.push(['load', {
        form: {
          selector: formNl,
          map: {
            subject: {
              email: 'contact[email]'
            },
            preferences: {
                privacy: "privacy",
                newsletter: "newsletter"
            },
          }
        },
          consent: {
              legal_notices: [
                {
                  identifier: "privacy_policy",
                },
                {
                  identifier: "cookie_policy",
                }
            ]
          }
      }]);


  formNl?.addEventListener('submit', function (e) {
    _iub.cons.sendData();

});


  } catch(e) { console.error(e); }
})();
      })();
